import { createTheme } from "@mui/material/styles";
import { muiThemeOptions } from "@tactical-agent-neural-knowledge/sdk/blocks-web";
import { brand } from "@tactical-agent-neural-knowledge/sdk/design";

const focusRing = {
  outline: `2px solid ${brand.neuralNeonCyan}`,
  outlineOffset: 2,
} as const;

// The brand theme from the SDK (dark-first, light scheme included, CSS variables on), plus a keyboard focus ring
// in Neural Neon Cyan for every focusable surface. Importing from blocks-web also brings the `palette.tank.*`
// module augmentation.
export const themeOverrides = {
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ":focus-visible": focusRing,
        "[data-drag-over] *": { pointerEvents: "none" },
        // Used by scrollers that sit beside the Topo strip, which is itself a position indicator:
        // the native bar next to it is redundant. Scrolling and keyboard paging are unaffected.
        ".tank-no-scrollbar": { scrollbarWidth: "none", msOverflowStyle: "none" },
        ".tank-no-scrollbar::-webkit-scrollbar": { width: 0, height: 0, display: "none" },
      },
    },
    MuiButtonBase: { styleOverrides: { root: { "&.Mui-focusVisible": focusRing } } },
    MuiListItemButton: {
      styleOverrides: { root: { "&.Mui-focusVisible": { ...focusRing, outlineOffset: -2 } } },
    },
  },
} as const;

export const theme = createTheme(muiThemeOptions, themeOverrides);
